import { ajax } from 'ajax';
import { useMainStore } from 'store';

export function get_custom_image_class( win, doc, disable_content_editable ) {
	const template = doc.createElement( `template` );

	template.innerHTML = `<link href="/build/css/custom-image.css" rel="stylesheet" type="text/css">`;

	return class CustomImage extends win.HTMLElement {
		static observedAttributes = [`uuid`];

		constructor() {
			super();

			if( disable_content_editable ) {
				this.setAttribute( `contenteditable`, false );
			}

			this.attachShadow( {
				mode: `open`
			} );

			this.shadowRoot.appendChild( template.content.cloneNode( true ) );
		}

		start_loading() {
			const spinner_el = document.createElement( `div` );
			spinner_el.classList.add( `spinner` );

			let i = 0;
			while( i < 12 ) {
				const div_el = document.createElement( `div` );
				spinner_el.appendChild( div_el );
				i++;
			}

			this.shadowRoot.appendChild( spinner_el );
		}

		stop_loading() {
			const el = this.shadowRoot.querySelector( `.spinner` );
			if( !el ) {
				return;
			}

			el.parentNode.removeChild( el );
		}

		set_error( text ) {
			const error_el = document.createElement( `div` );
			error_el.classList.add( `error` );
			error_el.textContent = `ERROR: ${text}`;
			this.shadowRoot.appendChild( error_el );
		}

		set_image( response ) {
			const figure = document.createElement( `figure` );

			const image = document.createElement( `img` );
			image.setAttribute( `width`, response.width );
			image.setAttribute( `height`, response.height );
			image.setAttribute( `src`, response.current_site_url );
			image.setAttribute( `alt`, response.alt );

			figure.appendChild( image );

			if( response.caption !== `` ) {
				const caption = document.createElement( `figcaption` );
				caption.innerText = response.caption;
				figure.appendChild( caption );
			}

			this.shadowRoot.appendChild( figure );
		}

		connectedCallback() {
			const uuid = this.getAttribute( `uuid` );
			if( !uuid || uuid === `` ) {
				this.set_error( `Image UUID not set` );
				return;
			}

			this.start_loading();

			const store = useMainStore();

			ajax( {
				method: `GET`,
				endpoint: store.member?.uuid ? `api/members/media/${uuid}` : `admin/media/${uuid}`,
				on_success: response => {
					this.stop_loading();

					if( !response.mime_type.startsWith( `image/` ) ) {
						this.set_error( `Media file is not an image` );
						return;
					}

					if( response.status !== `public` ) {
						this.set_error( `Image is not public` );
						return;
					}

					this.set_image( response );
				},
				on_error: response => {
					this.stop_loading();
					this.set_error( response );
				}
			} );
		}
	};
}
